import { useState, useEffect } from 'react';
import Page from '../components/Page';
import image from '../static/images/conduct.jpg';
import cocPDF from '../static/pdf/De School Code of Conduct.pdf';


const CodeOfConduct = (props) => {

  const [innerContent, setInnerContent] = useState('');
  const [innerContentEN, setInnerContentEN] = useState('');




  useEffect(() => {
    fetch('./content/codeofconduct-NL.html').then((response) => {
    return response.text();
    }).then((html) => {
    setInnerContent(html);
  });

    fetch('./content/codeofconduct-EN.html').then((response) => {
    return response.text();
    }).then((html) => {
    setInnerContentEN(html);
  });
    },[]);

  const content = <div className="content"
    dangerouslySetInnerHTML={{__html: innerContent ? innerContent : ''}}></div>

  const contentEN = <div className="content"
  dangerouslySetInnerHTML={{__html: innerContentEN ? innerContentEN : ''}}></div>

  document.title = 'Code of Conduct - De School Amsterdam';
  const headerTitle = 'Code of Conduct';
  const description = 'Conduct Conduct Conduct Conduct Conduct Conduct';


  return <Page
          headerTitle={headerTitle}
          description={description}
          content={props.langNL ? content : contentEN}
          image={image}
          langNL={props.langNL}
          changeLang={props.changeLang}/>


};

export default CodeOfConduct;
